import { combineReducers } from "redux";
import { CHANGE_AREA_STATUS_REQUEST, CHANGE_AREA_WEIGHT_REQUEST, FETCH_AREAS_REQUEST } from "./constants";
import { arrayToObject } from "../../utils/arrayToObject";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { Action } from "./types";
import { Area } from "../types";
type AreaItem = Area & {
  isFetching: boolean;
};
type Items = {
  [key: number]: AreaItem;
};
function items(state: Items = {}, action: Action): Items {
  switch (action.type) {
    case getSuccessActionType(FETCH_AREAS_REQUEST):
      return arrayToObject(action.payload);

    case CHANGE_AREA_STATUS_REQUEST:
    case CHANGE_AREA_WEIGHT_REQUEST:
      return { ...state, [action.data.areaId]: { ...state[action.data.areaId], isFetching: true } };

    case getSuccessActionType(CHANGE_AREA_STATUS_REQUEST):
    case getSuccessActionType(CHANGE_AREA_WEIGHT_REQUEST):
      return { ...state, [action.data.areaId]: { isFetching: false, ...action.payload } };

    case getFailureActionType(CHANGE_AREA_STATUS_REQUEST):
    case getFailureActionType(CHANGE_AREA_WEIGHT_REQUEST):
      return { ...state, [action.data.areaId]: { ...state[action.data.areaId], isFetching: false } };

    default:
      return state;
  }
}

function isFetching(state = false, action: Action) {
  switch (action.type) {
    case FETCH_AREAS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_AREAS_REQUEST):
    case getFailureActionType(FETCH_AREAS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const areas = combineReducers({ items, isFetching });
